import Model from './Model'

export default class History extends Model {
    resource()
    {
        return 'histories'
    }
}